import React, { useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { enqueueSnackbar } from 'notistack';
import theme from '@/constants/theme';

interface CoverImageProps {
  image: string | File | null;
  setImage: React.Dispatch<React.SetStateAction<string | File | null>>;
}

export const CoverImage: React.FC<CoverImageProps> = ({ image, setImage }) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      const file = acceptedFiles[0];
      file && setImage(file);
    },
    [setImage],
  );

  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    noClick: true,
    onDrop,
    maxFiles: 1,
    accept: {
      'image/*': [],
    },
    multiple: false,
  });

  useEffect(() => {
    if (fileRejections && fileRejections.length > 0) {
      enqueueSnackbar({
        variant: 'error',
        message: 'Se exedió la cantidad máxima de archivos o el formato no es válido',
      });
    }
  }, [fileRejections]);

  return (
    <label
      style={{
        display: 'flex',
        gap: 8,
        backgroundColor: theme.colors.background.secondary,
        border: `2px dashed ${theme.colors.border}`,
        color: theme.colors.text.body,
        padding: 16,
        alignItems: 'center',
        justifyContent: 'center',
        height: 240,
        flexDirection: 'column',
        cursor: 'pointer',
      }}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <span>
        {image
          ? 'Presionar o arrastrar para cambiar la imagen'
          : 'Presionar o arrastrar para subir una imagen'}
      </span>
      {image && (
        <img
          src={typeof image === 'string' ? image : URL.createObjectURL(image)}
          alt="coverImage"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      )}
    </label>
  );
};
